import styled from 'styled-components';

export const IconBox = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(37, 157, 248, 0.1);
`;
